import {
  SAVE_DASTE_PROFILE_LIST,
  SAVE_PRICE_PROFILE,
  SAVE_TYPE_COLOR_LIST,
  SERI_PROFILE_TBL_DATA,
  UPDATE_PROFILE_COLUMN,
  SAVE_TYPES,
  GET_ALL_TYPE_AND_COLOR,
  SAVE_SELECT_COLOR,
  SELECTED_DASTE_PROFILE,
  SAVE_FIXER_DATA,
  SAVE_LASTIK_DATA,
  SAVE_KASRI_BORESH_DATA,
  ACTION_GET_COLOR_PROFILE_RELATION,
  ACTION_GET_DASTE_PROFILE_RELATION,
  ACTION_GET_TYPE_PROFILE_RELATION,
  SELECTED_TYPE_COLOR,
  SEARCHPROFILECATEGORY,
  SEARCHPROFILETYPECOLOR,
} from "Stores/actionTypes";
import { updateObject } from "Stores/reducers/utility";

const initialState = {
  colors: [],
  types: [],
  allTypeColors: [],
  typeColorList: [],
  dasteProfileList: [],
  selectedDasteProfile: null,
  selectedTypeColor: null,
  priceProfileData: [],
  profileTblData: [],
  fixerData: null,
  lastikData: null,
  kasriBoreshData: null,
  dataRelationColor: [],
  dataRelationType: [],
  dataRelationDasteProfile: [],
  profileTblDataPagination:{Limit: 10, Page: 1, Total: 0 },
  priceProfileDataPagination:{Limit: 10, Page: 1, Total: 0 },
  allTypeColorsPagination:{Limit: 10, Page: 1, Total: 0 },
  profileCategorySearch: "",
  profileTypeColorSearch: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_TYPE_AND_COLOR:
      return updateObject(state, {
         allTypeColors: action.allTypeColors,
         allTypeColorsPagination: action.allTypeColorsPagination
         });
    case SAVE_KASRI_BORESH_DATA:
      return updateObject(state, { kasriBoreshData: action.kasriBoreshData });
    case SAVE_LASTIK_DATA:
      return updateObject(state, { lastikData: action.lastikData });
    case SAVE_FIXER_DATA:
      return updateObject(state, { fixerData: action.fixerData });
    case SAVE_SELECT_COLOR:
      return updateObject(state, { colors: action.colors });
    case SAVE_TYPES:
      return updateObject(state, { types: action.types });
    case SERI_PROFILE_TBL_DATA:
      return updateObject(state, {
         profileTblData: action.profileTblData,
         profileTblDataPagination: action.profileTblDataPagination,
         });
    case UPDATE_PROFILE_COLUMN:
      return updateObject(state, { profileCol: action.profileCol });
    case SAVE_PRICE_PROFILE:
      return updateObject(state, {
         priceProfileData: action.priceProfileData,
         priceProfileDataPagination: action.priceProfileDataPagination 
        });
    case SAVE_TYPE_COLOR_LIST:
      return updateObject(state, { typeColorList: action.typeColorList });
    case SAVE_DASTE_PROFILE_LIST:
      return updateObject(state, {
        dasteProfileList: action.dasteProfileList,
        selectedDasteProfile: action.selectedDasteProfile,
      });
    case SELECTED_DASTE_PROFILE:
      return updateObject(state, {
        selectedDasteProfile: action.selectedDasteProfile,
      });
    case SELECTED_TYPE_COLOR:
      return updateObject(state, {
        selectedTypeColor: action.selectedTypeColor,
      });
    case ACTION_GET_COLOR_PROFILE_RELATION:
      return updateObject(state, {
        dataRelationColor: action.dataRelationColor,
      });
    case ACTION_GET_TYPE_PROFILE_RELATION:
      return updateObject(state, { dataRelationType: action.dataRelationType });
    case SEARCHPROFILECATEGORY:
      return updateObject(state, { profileCategorySearch: action.data });
    case SEARCHPROFILETYPECOLOR:
      return updateObject(state, { profileTypeColorSearch: action.data });
    case ACTION_GET_DASTE_PROFILE_RELATION:
      return updateObject(state, {
        dataRelationDasteProfile: action.dataRelationDasteProfile,
      });
    default:
      return state;
  }
};

export default reducer;
